<template>
  <div class="marketing-swiper" v-swiper:mySwiper="swiperOptions" :style="customStyle">
      <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in images" :key="index" @click="trackSelect(item, index)">
              <img class="swiper-image" :style="{ height: swiperImageHeight}" :src="item" />
          </div>
      </div>
      <div class="swiper-pagination"></div>
  </div>
</template>
<script>
import 'swiper/dist/css/swiper.css';
export default {
    props: {
        customStyle: String,
        images: {
            type: Array,
            value: []
        },
        height: {
            type: Number,
            value: 300
        },
        interval: {
            type: Number,
            default: 5
        },
        trackSelectAction: Function
    },
    data() {
        return {
            observers: [],
            exposeTimers: {}
        };
    },
    computed: {
        swiperOptions() {
            const autoplaySetting = {
                delay: this.interval ? this.interval * 1000 : 5000,
                disableOnInteraction: false,
                observer: true
            };
            return {
                // 自动播放
                autoplay: this.interval === 0 ? false : autoplaySetting,
                // 环路播放
                loop: true,
                // 分页器
                pagination: {
                    el: '.swiper-pagination'
                }
            };
        },
        swiperImageHeight() {
            return `${this.height * 100 / 750}vw`;
        }
    },
    mounted() {
        this.observers = [
            ...document.querySelectorAll('.swiper-image')
        ].map(ele => {
            return {
                observer: new IntersectionObserver(
                    val => this.trackExposeCallBack(val, ele.currentSrc),
                    {
                        rootMargin: '0px',
                        threshold: 0.5
                    }
                ),
                ele: ele
            };
        });
        this.observers.map(i => i.observer.observe(i.ele));
    },
    beforeDestroy() {
        if (this.observers && this.observers.length) {
            this.observers.map(i => i.observer && i.observer.unobserve(i.ele));
        }
    },
    methods: {
        trackExposeCallBack(val, src) {
            if (!val[0]) return;
            if (val[0].isIntersecting) {
                this.exposeTimers[src] = setTimeout(() => {
                    const custom = this.getTrackInfo(src);
                    this.trackExposeAction(custom);
                }, 1000);
            } else {
                clearTimeout(this.exposeTimers[src]);
            }
        },
        getTrackInfo(src) {
            return {
                image: src,
                position_in_rank: this.images.findIndex(i => i === src) + 1
            };
        },
        trackExposeAction(custom) {
            this.$emit('trackExposeAction', {
                position_in_number: this.images.length,
                ...custom
            });
        },
        trackSelect(src, index) {
            if (this.trackSelectAction) {
                this.trackSelectAction({
                    image: src,
                    position_in_number: this.images.length,
                    position_in_rank: index + 1
                });
            }
        }
    }
};
</script>
<style lang="less">
@import '~src/assets/css/variable.less';
.marketing-swiper {
    display: flex;
    flex-direction: column;
    .swiper-pagination-bullets {
        top: none;
        bottom: 15 * @layout375;
    }
    .swiper-pagination-bullet {
        width: 5 * @layout375;
        height: 5 * @layout375;
        border-radius: 3 * @layout375;
        background-color: #ffffff;
        opacity: 0.5;
        transition: all 0.3s linear 0s;
        &.swiper-pagination-bullet-active {
            width: 15 * @layout375;
            opacity: 1;
        }
    }
    .swiper-image {
        object-fit: cover;
        vertical-align: bottom;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/marketing/components/swiper.vue